import EventControls from './EventControls';

export default EventControls;
export type { EventControlsProps } from './EventControls';
